import { privateAPI } from "@/shared/lib";
import type { ServiceResponse } from "@/shared/lib/axios";
import { needsSyncRefillSchema } from "../models";

export const getNeedsSyncRefill = async () => {
  const { data } = await privateAPI.get<ServiceResponse<unknown>>(
    "/patients/needs-sync-refill",
  );

  return needsSyncRefillSchema.parse(data.data);
};
